import { Ref, RefString } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { Beepers } from "../Beepers";
import { LedStatus } from './LedStatus';
import { StatusEvent } from './StatusEvent';


export class Status
{
    private deviceId: string = "";
    private currentStatus: StatusEvent | null = null;
    public TextStatus = new RefString("");
    public LedStatus = new Ref<LedStatus>(LedStatus.Idle);
    public TitleStatus = new RefString("⚪");
    public TimerText = new RefString("🕑");
    private timeFromLastStatusChange = 0;
    private preventUntil: StatusEvent[] = [];
    private cameraConnected = false;
    private serverConnected = false;
    private cameraHalted = false;
    private timer: NodeJS.Timeout;

    constructor(private _lang: Translations, private _beeper: Beepers)
    {
        this.timer = setInterval(() => 
        {
            this.TimerText.value = this.timeFromLastStatusChange.toFixed(1) + " s";
            this.timeFromLastStatusChange += 0.5;
        }, 500);
    }

    public Dispose(): void
    {
        clearInterval(this.timer);
    }

    public SetDeviceId(deviceId: string)
    {
        this.deviceId = deviceId;
        this.SetWindowTitle(this.TitleStatus.value + " " + this.deviceId);
    }

    private lastTitle: string = "";
    public SetWindowTitle(title: string): void
    {
        if (this.lastTitle != title)
        {
            // $('title')?.Text(title); // This is danger on Chrome! After about 400 calls the app will freeze!
            document.title = title;
            this.lastTitle = title;
        }
    }

    public PictureReceived(pictureIndex: number): void
    {
        this.Set(StatusEvent.PictureReceived);
        this.TextStatus.value = this._lang.PictureReceived + " #" + pictureIndex;
    }

    public InputActive(inputName: string): void
    {
        this.Set(StatusEvent.InputActive);
    }

    public SetStatus(icon: string, led: LedStatus, text?: string): void
    {
        if (text)
            this.TextStatus.value = text;
        this.LedStatus.value = led;
        this.TitleStatus.value = icon;
        this.SetWindowTitle(icon + " " + this.deviceId);
    }

    public Set(event: StatusEvent): void
    {
        if (this.preventUntil.length == 0 || this.preventUntil.includes(event))
        {
            this.preventUntil = [];

            switch (event)
            {
                case StatusEvent.Launching:
                    this.SetStatus("🚀 " + this._lang.Launching, LedStatus.Idle, this._lang.Launching);
                    break;
                case StatusEvent.CameraConnected:
                    this.cameraConnected = true;
                    // this.serverConnected = true;
                    this.SetStatus("🟢", LedStatus.CameraConnected, this._lang.CameraConnected);
                    break;
                case StatusEvent.CameraDisconnected:
                    this.cameraConnected = false;
                    // this.serverConnected = true;
                    this.SetStatus("⚪", LedStatus.CameraDisconnected, this._lang.CameraNotConnected);
                    break;
                case StatusEvent.PictureReceived:
                    this.cameraConnected = true; // Ponieważ zdarzenie CameraConnected nie zawsze jest wysyłane
                    this.cameraHalted = false; // TODO: zwykle jeszcze przychodzi obrazek po wysłaniu halt, więc tu jest problem!

                    if (!this.cameraHalted)
                        this.SetStatus("🟢", LedStatus.NewPictureReceived);
                    this.LedStatus.ForceOnChange();
                    break;
                case StatusEvent.CameraHalted:
                    this.cameraHalted = true;
                    this.SetStatus("🔵", LedStatus.CameraHalted, this._lang.CameraHalted);
                    break;
                case StatusEvent.InputActive:
                    this.preventUntil = [
                        StatusEvent.InputInactive,
                        StatusEvent.ServerDisconnected,
                        StatusEvent.CameraDisconnected];
                    this.SetStatus("🟡", LedStatus.InputActive); // "Wejście #" + extraMessage + " aktywne"
                    break;
                case StatusEvent.InputInactive:
                    if (this.cameraConnected)
                    {
                        if (this.cameraHalted)
                            this.SetStatus("🔵", LedStatus.CameraHalted, this._lang.CameraHalted);
                        else
                            this.SetStatus("🟢", LedStatus.CameraConnected);
                    }
                    else
                        this.SetStatus("⚪", LedStatus.CameraDisconnected);
                    if (this.serverConnected === false)
                        this.SetStatus("🔴", LedStatus.ServerDisconnected, this._lang.NoConnectionToServer);
                    break;
                case StatusEvent.ServerDisconnected:
                    this.serverConnected = false;
                    this.SetStatus("🔴", LedStatus.ServerDisconnected, this._lang.NoConnectionToServer);
                    break;
                case StatusEvent.ServerConnected:
                    this.serverConnected = true;
                    const msg = this._lang.ConnectedToServer + ", " + (this.cameraConnected ? this._lang.CameraConnected : this._lang.CameraNotConnected).toLowerCase();
                    this.SetStatus("⚪", LedStatus.ServerConnected, msg);
                    break;
                case StatusEvent.Unauthorized:
                    this.preventUntil = [
                        StatusEvent.ServerConnected
                    ];
                    // TODO: Zaraz po tym zdarzeniu wpada ServerDisconnected więc albo trzeba to zablokować albo usunąć
                    this.SetStatus("❌", LedStatus.Unauthorized, this._lang.Unauthorized);
                    break;
                case StatusEvent.Malfunction:
                    this.SetStatus("🟠", LedStatus.ProblemWithCamera, this._lang.Malfunction);
                    break;
            }

            this.currentStatus = event;

            // Timer
            this.timeFromLastStatusChange = 0;
        }
    }

    public get CurrentStatus(): StatusEvent | null
    {
        return this.currentStatus;
    }
}